import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiSolidCheckCircle, BiSolidXCircle } from "react-icons/bi";
import UploadReport from "./uploadReport";
import TestForPackage from "./testsByPackagePopup";
import { FiInfo } from "react-icons/fi";
import AdminDashboard from "./admindashboard";
import { Pagination } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";

function ReportsApproval() {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [filter, setFilter] = useState("REQUESTED"); // Default filter set to "REQUESTED"
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getData = async (pageNumber = 0, status = filter) => {
    const token = JSON.parse(localStorage.getItem("data")).token;

    setLoader(true);
    try {
      const response = await axios.get(`/api/employeeappointment/getAllUploadedReports`, {
        params: { page: pageNumber, status: status === "ALL" ? null : status },
        headers: { Authorization: `Bearer ${token}` },
      });
      setAppointmentDetails(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, [filter]); // Refresh data when filter changes

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setCurrentPage(0); // Reset to first page when changing filter
  };


  const handlePageChange = (pageNumber) => {
    getData(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };


  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleViewReport = (reportId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    const url = `/api/employee-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    axios({
      url: `/api/employee-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };

  const [loading, setLoading] = useState(null);
  function rsubmit(e, id, status) {
    e.preventDefault();
    setLoading(id);

    const token = JSON.parse(localStorage.getItem("data")).token;

    const entitiesToUpdate = ({
      id: id,
      reportstatus: status,
    });

    axios
      .post(
        "/api/employeeappointment/approve",
        entitiesToUpdate,
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        setLoading(null);
        getData();
      })
      .catch((error) => {
        handleError(error);
      });
  }

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };



  return (
    <div>
      <AdminDashboard />
      <div className="col-12 mx-xl-auto ps-xl-10 mt-10">
        <div className="card card-raised">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
              Reports Approval</div>

            <div className="d-flex col-3 mb-3 mt-2">
              <label htmlFor="statusFilter" className="form-status">
                Filter by Status:
              </label>
              <select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="form-select mb-3"
              >
                <option value="ALL">ALL</option>
                <option value="REQUESTED">REQUESTED</option>
                <option value="APPROVED">APPROVED</option>
                <option value="REJECTED">REJECTED</option>
              </select>
            </div>
            <table className="table table-bordered">
              <thead>
                <tr className="table-header">
                  <th>Lab Name</th>
                  <th>Company Name</th>
                  <th>Employee Name</th>
                  <th>Date</th>
                  <th>Contact Number</th>
                  <th>Package Name</th>
                  <th>Appointment Status</th>
                  {/* <th>Report Id</th> */}
                  <th>Reports</th>
                  <th>Report Status</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment) => (
                    <tr key={appointment.id}>
                      <td>{appointment.labs?.labname}</td>
                      <td>{appointment.company?.companyname}</td>
                      <td>{appointment.emplo?.name} {appointment.emplo?.lastname}</td>
                      <td>{appointment.date}</td>
                      <td>{appointment.emplo?.phoneno}</td>
                      <td>
                        {appointment.pack !== null && (
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                            <span style={{
                              backgroundColor: '#405469ff',
                              color: 'white',
                              padding: '6px 12px',
                              borderRadius: '20px',
                              fontWeight: '500',
                              display: 'inline-block',
                              fontSize: '14px'
                            }}>{appointment.pack?.packagename}</span>
                            <FiInfo
                              onClick={() => openTestsModal(appointment.packageid)}
                              style={{
                                cursor: 'pointer',
                                fontSize: '24px',
                              }}
                            />
                          </div>
                        )}
                        <div>
                          {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                            <>
                              {appointment.pack !== null ? "Additional Tests:" : "Tests:"}
                              <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                {
                                  appointment.additionalTest.map((test, i) => (
                                    <li key={i}>{test.testDetails?.testname}</li>
                                  ))

                                }
                              </ul>
                            </>
                          )}
                        </div>
                      </td>
                      <td>{appointment.appStatus?.appointmentStatus}</td>
                      {/* <td>
                        {(appointment.reports || []).length > 0 ? (
                          <ul className="list-unstyled mb-0">
                            {(appointment.reports || []).map((report) => (
                              <li key={report.id}>{report.id}</li>
                            ))}
                          </ul>
                        ) : "N/A"}
                      </td> */}
                      <td>

                        {appointment.orderStatus?.appointmentReport ? (
                          <div>
                            {/* Display the appointment report as a link if approved */}
                            <a
                              href={appointment.orderStatus.appointmentReport}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Report
                            </a>
                          </div>
                        ) : (
                          appointment.reportstatus ? (
                            <>
                              {(appointment.reports || []).length > 0 ? (
                                <ul className="list-unstyled mb-0">
                                  {(appointment.reports || []).map((report, ri) => (
                                    <li key={report.id} className="d-flex align-items-center justify-content-between mb-1" style={{ gap: '6px' }}>
                                      <span
                                        style={{ cursor: 'pointer', color: '#0d6efd', textDecoration: 'underline', fontSize: '13px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                                        onClick={() => handleViewReport(report.id)}
                                        title={report.fileName || `File ${ri + 1}`}
                                      >
                                        {report.fileName || `File ${ri + 1}`}
                                      </span>
                                      <FaDownload
                                        size={14}
                                        style={{ cursor: 'pointer', color: '#198754', flexShrink: 0 }}
                                        title="Download"
                                        onClick={() => handleDownloadReport(report.id, report.fileName)}
                                      />
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <span className="text-muted" style={{ fontSize: '12px' }}>No files</span>
                              )}
                            </>
                          ) : (
                            "No Report Added"
                          ))}
                      </td>
                      <td>
                        {appointment.reportstatus ? (
                          <>
                            {appointment.reportstatus === "REQUESTED" ? (
                              <td id="icon" value={appointment.reportstatus}>
                                &nbsp;
                                {appointment.reportstatus} &nbsp;
                                {loading && (
                                  <div
                                    className="loader"
                                    style={{
                                      position: "relative",
                                      left: "75px",
                                      top: "10px",
                                    }}
                                  ></div>
                                )}{" "}
                                <BiSolidCheckCircle
                                  className="icon"
                                  id="appointment.reportstatus"
                                  style={{ backgroundColor: "green", cursor: "pointer" }}
                                  value="APPROVED"
                                  title="Approve"
                                  onClick={(e) =>
                                    rsubmit(e, appointment.id, "APPROVED")
                                  }
                                />
                                &ensp;
                                <BiSolidXCircle
                                  className="icon"
                                  value="REJECTED"
                                  style={{ backgroundColor: "red", cursor: "pointer" }}
                                  id="appointment.reportstatus"
                                  title="Reject"
                                  onClick={(e) =>
                                    rsubmit(e, appointment.id, "REJECTED")
                                  }
                                />
                              </td>
                            ) : (
                              <td id="icon" value={appointment.reportstatus}>
                                {" "}
                                {appointment.reportstatus}
                              </td>
                            )}
                          </>
                        ) : (
                          null
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Pagination>
              <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
              <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
              {renderPageNumbers()}
              <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
              <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
            </Pagination>
          </div>
        </div>

        {isTestsModalOpen && (
          <TestForPackage
            isOpen={isTestsModalOpen}
            onRequestClose={closeTestsModal}
            packageId={selectedPackage}
          />
        )}
        {loader && <div className="loading"></div>}
      </div>
    </div>
  );
}

export default ReportsApproval;
